import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import c from 'common/constants/flux-events';
import selector from './selector';
import AdForm from 'forms/ad-form';
import actions from 'pages/ad-form/ad-edit-form/actions';

class AdEditForm extends React.Component {
    handleButtonClick_submit = draft => {
        const {
            dispatch,
            params: { campaignId, adId },
        } = this.props;

        return dispatch(actions.submitDraft(draft, campaignId, adId)).then(() => {
            browserHistory.push(`/campaigns/${campaignId}/setup/ads`);
        });
    };

    handleButtonClick_cancel = () => {
        const { campaignId, isSubmiting } = this.props;

        if (isSubmiting) {
            reutrn;
        }

        browserHistory.push(`/campaigns/${campaignId}/setup/ads/`);
    };

    getInitialDraft = () => {
        const { campaignId, adId } = this.props.params;

        return this.props.dispatch(actions.open(campaignId, adId));
    };

    render() {
        const { campaignId, adId } = this.props.params;

        if (this.props.loading) {
            return <div>loading...</div>;
        }

        return (
            <div>
                <AdForm
                    submit={this.handleButtonClick_submit}
                    cancel={this.handleButtonClick_cancel}
                    campaignId={campaignId}
                    adId={adId}
                    getInitialDraft={this.getInitialDraft}
                />
                {this.props.workspace}
            </div>
        );
    }
}

export default connect(selector)(AdEditForm);
